<template>
  <div id="sidebar-narrow" :class="sidebarClass">
    <Cover @click = "handleHideSubmenu" :show="showExpand"/>
    <SubMenu :content = "submenuContents"
             :showExpand = "showExpand"
             :ismobile="isMobile"
             :ismobileexpanded="isMobileExpanded"
             :activeElementID = "selectedItemIdx"
             @submenu-keypress-fold="handleHideSubmenu"
    />
    <SidebarMain @on-expand = "handleExpand"
                 :isMenuExpanded="showExpand"
                 :ismobile="isMobile"
                 :ismobileexpanded="isMobileExpanded"
                 :showExtraMenu = "showExtraMenu"
                 @on-jump-to-submenu = "focusSubmenu"


    />
    <teleport to="#topleftlogo">
        <HeaderLogoHamburger :ismobile="isMobile"
                             @on-show-hide-sidebar="handleHamburgerClick"
        ></HeaderLogoHamburger>
    </teleport>
  </div>
</template>

<script>
import SidebarMain from './components/SidebarMain.vue'
import SubMenu from './components/SubMenu.vue'
import Cover from './components/Cover.vue'
import HeaderLogoHamburger from './components/HeaderLogoHamburger.vue'
export default {
  name: 'App',
  components: {
    SidebarMain,
    SubMenu,
    Cover,
    HeaderLogoHamburger
  },
  data:function(){
    return{
      submenuContents:{
        expand:[],
        icon:'',
        title:''
      },
      selectedItemIdx:false,
      showExpand:false,
      mobileBreakpoint:680,
      isMobile:false,
      showExtraMenu:false,
      isMobileExpanded:false
    }
  },
  mounted() {
    this.isMobile = document.body.clientWidth<=this.mobileBreakpoint;
    this.showExtraMenu = document.body.clientWidth<=1114;
    const extraMenuQuery = window.matchMedia('(max-width: 1114px)');
    this.showExtraMenu = extraMenuQuery.matches;
    window.addEventListener('resize', function(){
      this.isMobile = document.body.clientWidth<=this.mobileBreakpoint;
      const extraMenuQuery = window.matchMedia('(max-width: 1114px)');
      this.showExtraMenu = extraMenuQuery.matches;
      // this.showExtraMenu = document.body.clientWidth<=1114;
    }.bind(this));
  },
  computed:{
    sidebarClass(){
      if(this.isMobile && !this.isMobileExpanded){
        return 'hideMobile';
      }
      return '';
    }
  },
  methods:{
    handleExpand:function (payload) {
      console.log('payload')
      console.log(payload)
      console.log(this.showExpand);
      if(this.showExpand && payload.idx==this.selectedItemIdx){
        this.showExpand = false;
      }else{
        this.showExpand = true;
      }
      this.submenuContents = payload;
      this.selectedItemIdx = payload.idx;
    },
    focusSubmenu:function (payload){
      console.log(payload);
    },
    handleHideSubmenu:function (){
      this.showExpand = false;
    },
    handleHamburgerClick:function () {
      console.log('handle hamburger')
      this.isMobileExpanded = !this.isMobileExpanded;
    }
  }
}
</script>

<style>
body{
  min-height:100%;
}
#sidebar-narrow {
  position:fixed;
  height:100%;
  top:77px;
  z-index: 2100;
}
#sidebar{

}

</style>
